module.exports = __webpack_public_path__ + "static/img/logo-collapse.edc1b29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-collapse.png
// module id = Xv1f
// module chunks = 1